import { useStaticQuery, graphql } from "gatsby"

// return an id-based object of all persona descriptions
// with ids as keys
// {
// 	1: {text: 'text for persona 1'},
// 	2: {text: 'text for persona 2'}
// }
export const usePersonaDescData = startupName => {
  const data = useStaticQuery(graphql`
    {
      allPersonaDescriptionsJson {
        edges {
          node {
            text
            title
            title_plain
            persona_description_id
          }
        }
      }
    }
  `)

  const formattedData = data.allPersonaDescriptionsJson.edges.reduce(
    (obj, item) => {
      obj[item.node.persona_description_id] = {
        text: item.node.text.replace("__startup_name__", startupName),
        title: item.node.title.replace("__startup_name__", startupName),
        title_plain: item.node.title_plain.replace(
          "__startup_name__",
          startupName
        ),
      }
      return obj
    },
    {}
  )

  return formattedData
}
